// extracted by mini-css-extract-plugin
export default {"CardContainer":"ChallengeLevelOneInstructions_CardContainer__gSapH"};